import { createContext, useContext } from 'react';
import { Fieldset, Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const TRANS_KEY = 'FORM_FIELDS.CONTACT';
export const DEFAULT_SPAN = 6;

const DEFAULT_FIELD_PREFIX = 'contact';

export const ContactPrefixContext = createContext<string>(DEFAULT_FIELD_PREFIX);

export const useContactPrefix = (): string =>
  useContext(ContactPrefixContext) ?? DEFAULT_FIELD_PREFIX;

type RootPropsType = {
  children: React.ReactNode;
  fieldPrefix?: string;
  legend?: string;
};

export const Root: React.FC<RootPropsType> = ({
  children,
  fieldPrefix = DEFAULT_FIELD_PREFIX,
  legend,
}) => {
  const { t } = useTranslation();

  return (
    <ContactPrefixContext.Provider value={fieldPrefix}>
      <Fieldset legend={legend ?? t(`${TRANS_KEY}.CONTACT_LABEL`)}>
        <Grid>{children}</Grid>
      </Fieldset>
    </ContactPrefixContext.Provider>
  );
};
